@if (product) {
	<section class="product-additional-info">
		<div class="info-labels" fxLayout="column" fxLayoutGap="20px">
			@if (product.locale.shipping_info | getText; as shippingInfo) {
				<div fxLayout="row" fxLayoutAlign="start center" class="label delivery-info">
					<div class="g-icon-layers" fxFlex="40px">
						<g-icon class="circle" [icon]="icons.faCircle" />
						<g-icon [icon]="icons.faTruck" transform="translate(-60, 0) scale(0.45, 0.45)" inverse />
					</div>
					<span fxFlex>{{ shippingInfo }}</span>
				</div>
			}
			@if (showSupportLink) {
				<a
					fxLayout="row"
					fxLayoutAlign="start center"
					class="label support-link"
					[routerLink]="[supportLink]"
					fragment="contactRequest"
				>
					<div class="g-icon-layers" fxFlex="40px">
						<g-icon class="circle" [icon]="icons.faCircle" />
						<g-icon
							[icon]="icons.faBellConcierge"
							transform="translate(0, -12) scale(0.5, 0.5)"
							inverse
						/>
					</div>
					<span fxFlex i18n="@@ProductAdditionalSupportLink"
						>Need support? Contact our customer service.</span
					>
				</a>
			}
		</div>
	</section>
}
